module.exports = __webpack_public_path__ + "static/Kobold-ae8e6734385621861497a3294fdf5edc.jpg";